import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAppContext } from '../context/AppContext';

const footerStyles = {
  footer: {
    width: '100%',
    padding: { xs: '16px 16px', sm: '18px 32px' },
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    minHeight: { xs: '60px', sm: '80px' },
    borderTop: '1px solid',
  },
  leftText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 0 auto',
  },
  logo: {
    height: '40px',
    width: 'auto',
    opacity: '0.8',
    transition: 'opacity 0.3s ease',
    '&:hover': {
      opacity: '1',
    },
  },
  inlineIcon: {
    height: '16px',
    width: 'auto',
    verticalAlign: 'middle',
    marginLeft: '3px',
    marginRight: '3px',
  },
  rightText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    textAlign: 'right',
  },
};

const Footer = () => {
  const { themeMode } = useAppContext();

  return (
    <Box 
      component="footer"
      sx={{
        ...footerStyles.footer,
        backgroundColor: themeMode === 'dark' 
          ? 'rgba(36, 36, 36, 0.95)' 
          : 'rgba(255, 255, 255, 0.95)',
        borderTopColor: themeMode === 'dark'
          ? 'rgba(255, 255, 255, 0.15)'
          : 'rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box sx={footerStyles.leftText}>
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: { xs: '18px', sm: '20px', md: '24px' },
            fontWeight: 600,
            letterSpacing: '0.5px',
            color: themeMode === 'dark' ? '#ffffff' : '#000000',
          }}
        >
          Right by <span style={{ color: '#FF6B00', fontWeight: 600 }}>YOU</span>
        </Typography>
      </Box>
      <Typography 
        variant="body2" 
        sx={{
          ...footerStyles.rightText,
          fontSize: { xs: '11px', sm: '12px', md: '12px' },
          opacity: 0.7,
          color: 'text.secondary',
          flexWrap: 'wrap',
          maxWidth: { xs: '50%', sm: '60%', md: 'none' },
          gap: { xs: '2px', sm: '4px' },
          '&:hover': { opacity: 1 },
          a: {
            color: 'inherit',
            textDecoration: 'none',
            fontWeight: 'bold',
            display: 'inline-flex',
            alignItems: 'center',
            margin: { xs: '0 2px', sm: '0 4px' },
            whiteSpace: 'nowrap',
            '&:hover': {
              textDecoration: 'underline',
            },
          },
        }}
      >
        Created using
        <a 
          href="https://react.raaghu.ai" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img 
            src="https://raaghustorageaccount.blob.core.windows.net/raaghu-blob/raaghu-logo.png" 
            alt="Raaghu" 
            style={footerStyles.inlineIcon}
          />
          Raaghu Design System
        </a>
        with
        <a 
          href="https://waiin.com/ai-pundit" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img 
            src="https://raaghustorageaccount.blob.core.windows.net/raaghu-blob/pundit-color-logo.png" 
            alt="AI Pundit" 
            style={footerStyles.inlineIcon}
          />
          AI Pundit
        </a>
        leveraging
        <a 
          href="https://github.com/github/spec-kit" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <img 
            src="/spec-kit-logo.png" 
            alt="Raaghu" 
            style={footerStyles.inlineIcon}
          />
          spec-kit
        </a>
      </Typography>
    </Box>
  );
};

export default Footer;